export type LotHistoryRouteSearch = {
  partId?: string;
  lotNumber?: string;
  tagId?: string;
};

const text = (value: unknown): string | undefined =>
  typeof value === 'string' && value.trim() !== '' ? value.trim() : undefined;

/** A lot is addressed by part and lot number together, a stock tag by id; never both. */
export function parseLotHistoryRouteSearch(search: Record<string, unknown>): LotHistoryRouteSearch {
  const partId = text(search.partId);
  const lotNumber =
    typeof search.lotNumber === 'string' && search.lotNumber !== '' ? search.lotNumber : undefined;
  if (partId && lotNumber) {
    return { partId, lotNumber };
  }
  const tagId = text(search.tagId);
  return tagId ? { tagId } : {};
}
